import React from "react";
import "./FloatingButtons.css"; // Import CSS file

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919811145511" 
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Call Floating Button */}
      <a href="tel:+919811145511" className="call-float">
        <i className="fas fa-phone-alt"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
